import { render, staticRenderFns } from "./ColorForExpression.vue?vue&type=template&id=7ea0fd45"
import script from "./ColorForExpression.vue?vue&type=script&lang=js"
export * from "./ColorForExpression.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports